import { Flex, Icon } from "@chakra-ui/react";
import { RiErrorWarningLine } from "react-icons/ri";

import { OFText } from "design_system/components/OFText";
import { colors } from "src/colors";
import getNameProp from "src/utils/getNameProp";
import { formatPrice } from "src/utils/priceFormat";

interface Props {
  t: (key: string, values?) => string;
  display: boolean;
  minimalAmountPayment: number;
}

const MinimalAmountPaymentNotiSection = ({ t, display, minimalAmountPayment }: Props) => {
  if (!display) {
    return <></>;
  }
  return (
    <Flex
      justifyContent="space-between"
      my="24px"
      {...getNameProp("minimal-amount-payment-notification")}
      border="2px solid"
      borderColor={colors.orange[400]}
      borderRadius="8px"
      padding="8px 12px"
      mb="20px"
      alignItems="center"
    >
      <Icon as={RiErrorWarningLine} mr="5px" color={colors.orange[400]} h="28px" w="28px" />
      <OFText textStyle="labels">
        {t("checkout:minimal-amount-payment-noti", {
          minimal_amount: formatPrice(minimalAmountPayment)
        })}
      </OFText>
    </Flex>
  );
};

export default MinimalAmountPaymentNotiSection;
